/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Meetinglink_Placeholder1Inputs */

const en_job_form_meetinglink_placeholder1 = /** @type {(inputs: Job_Form_Meetinglink_Placeholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. https://zoom.eu/..`)
};

const de_job_form_meetinglink_placeholder1 = /** @type {(inputs: Job_Form_Meetinglink_Placeholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z. B. https://zoom.us/...`)
};

/**
* | output |
* | --- |
* | "e.g. https://zoom.eu/.." |
*
* @param {Job_Form_Meetinglink_Placeholder1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const job_form_meetinglink_placeholder1 = /** @type {((inputs?: Job_Form_Meetinglink_Placeholder1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Meetinglink_Placeholder1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_meetinglink_placeholder1(inputs)
	return en_job_form_meetinglink_placeholder1(inputs)
});
export { job_form_meetinglink_placeholder1 as "job_form_meetingLink_placeholder" }